import type { FC } from 'react'
import { IndexBarPanelProps } from './iIndexBar'

export const Panel: FC<IndexBarPanelProps> = () => null
